import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PolicyCreatePage } from '@/features/ai/agents/agents-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle politique d’agent. */
export const Route = createFileRoute('/$tenant/agent-policies/new')({ component: PolicyCreateRoute });

function PolicyCreateRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="agentPolicies"
      crumbs={[{ label: t('nav.items.agentPolicies') }]}
    >
      <PolicyCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
